function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32.8281 13C32.3164 13 31.8046 13.1954 31.4141 13.5859L30 15L35 20L36.4141 18.5859C37.1951 17.8049 37.1951 16.5388 36.4141 15.7578L34.2422 13.5859C33.8517 13.1954 33.3399 13 32.8281 13ZM28 17L16 29L17.5 29.5L18 32L20.5 32.5L21 34L33 22L28 17ZM14.1523 33.1523L13.0371 36.3086C13.0123 36.3693 12.9997 36.4344 13 36.5C13 36.6326 13.0527 36.7598 13.1465 36.8536C13.2402 36.9473 13.3674 37 13.5 37C13.5621 37.0003 13.6237 36.989 13.6816 36.9668L16.8477 35.8477L14.1523 33.1523Z"
});

function SvgIc2Af2B1Ca9Afa498FB05FC824Ad5Ca1F4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc2Af2B1Ca9Afa498FB05FC824Ad5Ca1F4);
export default ForwardRef;